"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendgridTemplateVersionToJSON = exports.SendgridTemplateVersionFromJSONTyped = exports.SendgridTemplateVersionFromJSON = void 0;
function SendgridTemplateVersionFromJSON(json) {
    return SendgridTemplateVersionFromJSONTyped(json, false);
}
exports.SendgridTemplateVersionFromJSON = SendgridTemplateVersionFromJSON;
function SendgridTemplateVersionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'user_id': json['user_id'],
        'template_id': json['template_id'],
        'active': json['active'],
        'name': json['name'],
        'html_content': json['html_content'],
        'plain_content': json['plain_content'],
        'updated_at': json['updated_at'],
        'created_at': json['created_at'],
        'generate_plain_content': json['generate_plain_content'],
        'subject': json['subject'],
        'test_data': json['test_data'],
    };
}
exports.SendgridTemplateVersionFromJSONTyped = SendgridTemplateVersionFromJSONTyped;
function SendgridTemplateVersionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'user_id': value.user_id,
        'template_id': value.template_id,
        'active': value.active,
        'name': value.name,
        'html_content': value.html_content,
        'plain_content': value.plain_content,
        'updated_at': value.updated_at,
        'created_at': value.created_at,
        'generate_plain_content': value.generate_plain_content,
        'subject': value.subject,
        'test_data': value.test_data,
    };
}
exports.SendgridTemplateVersionToJSON = SendgridTemplateVersionToJSON;
